import {DeepLinkActionBase} from "../deep-link-action-base";

export class ForgotPasswordDeeplinkAction extends DeepLinkActionBase {
    async execute(): Promise<void> {
        await this.services.externalLinks.openForgotPassword();
    }
}